import { AxiosResponse } from 'axios';
import {
  IAppointment,
  IAppointmentDTO,
} from '../shared/interfaces/appointment-interfaces';
import api from './api';

export interface IFetchAppointmentsRequestParams {
  date?: string;
  period?: string;
}

interface IScheduleService {
  create: (
    data: Omit<IAppointment, 'id'>,
  ) => Promise<AxiosResponse<IAppointment>>;
  list: (
    params?: IFetchAppointmentsRequestParams,
  ) => Promise<AxiosResponse<IAppointmentDTO[]>>;
  detail: (id: string) => Promise<AxiosResponse<IAppointmentDTO>>;
  delete: (id: string) => Promise<AxiosResponse>;
}

const appointmentService: IScheduleService = {
  create: data => api.post('/appointment/register_appointment', data),
  list: params =>
    api.get('/appointment/list_appointment', {
      params,
    }),
  detail: id => api.get(`/appointment/retrieve_appointment/${id}`),
  delete: id => api.delete(`/appointment/delete_appointment/${id}`),
};

export default appointmentService;
